// Tawk.to live chat widget loader.
// Only initializes when REACT_APP_TAWK_PROPERTY_ID + REACT_APP_TAWK_WIDGET_ID are set.
// Safe no-op when env vars are missing.
import { useEffect } from 'react';

const PROPERTY_ID = process.env.REACT_APP_TAWK_PROPERTY_ID;
const WIDGET_ID = process.env.REACT_APP_TAWK_WIDGET_ID || 'default';

export default function TawkChat() {
  useEffect(() => {
    if (!PROPERTY_ID) return undefined;
    if (window.Tawk_API) return undefined;
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://embed.tawk.to/${PROPERTY_ID}/${WIDGET_ID}`;
    s.charset = 'UTF-8';
    s.setAttribute('crossorigin', '*');
    document.body.appendChild(s);
    return undefined;
  }, []);
  return null;
}
